// extracted by mini-css-extract-plugin
export default {"modalContainer":"PdfModal_modalContainer__2DHRN","content":"PdfModal_content__1FrEW"};